import React, { Component } from "react";

import HeaderSection from "../Components/HeaderSection";
import DestinationSection from "../Components/DestinationSection";
import CallToAction from "../Components/CallToAction";
import FooterSection from "../Components/FooterSection";

export default class Homepage extends Component {
  render() {
    return (
      <React.Fragment>
        <HeaderSection />
        <DestinationSection />
        <CallToAction />
        <FooterSection />
      </React.Fragment>
    );
  }
}
